const ALLOWED_UNIT_FUNCTIONS = [
  "sum",
  "latest",
  "avg",
  "min",
  "max",
  "percentage",
  "stddev",
  "variance",
  "sumofsquares",
  "percentile"
];
const isFunctionAllowsUnit = (func) => ALLOWED_UNIT_FUNCTIONS.includes(func);
export default isFunctionAllowsUnit;
